import { render } from "./PatientsDatatableFormCard.vue?vue&type=template&id=60041137"
import script from "./PatientsDatatableFormCard.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableFormCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__